import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchSalesOrders } from '@/api/orders';
import type { SalesOrderListResponse } from '@/api/orders/types';
import { buildSalesOrdersApiBody } from '../-utils/listParams';

export const salesOrderKeys = {
  all: ['cascade-tracing', 'sales-orders'] as const,
  list: (body: Record<string, unknown>) =>
    [...salesOrderKeys.all, 'list', body] as const,
};

export function salesOrdersQueryOptions(params: {
  page: number;
  limit: number;
  isArchived: boolean;
  sort?: string;
  filters?: Record<string, string[]>;
}) {
  const body = buildSalesOrdersApiBody(params);
  return queryOptions({
    queryKey: salesOrderKeys.list(body),
    queryFn: () => fetchSalesOrders(body),
    staleTime: 30_000,
  });
}

export function useSalesOrdersList(params: {
  page: number;
  limit: number;
  isArchived: boolean;
  sort?: string;
  filters?: Record<string, string[]>;
}) {
  const body = buildSalesOrdersApiBody(params);

  return useQuery({
    queryKey: salesOrderKeys.list(body),
    queryFn: () => fetchSalesOrders(body),
    staleTime: 30_000,
    refetchInterval: query => {
      const data = query.state.data as SalesOrderListResponse | undefined;
      const orders = data?.data ?? [];
      const hasProcessing = orders.some(
        o =>
          o.aiSummary?.docType?.status === 'PREPARING' ||
          o.aiSummary?.docType?.status === 'PROCESSING' ||
          o.aiSummary?.docContent?.status === 'PREPARING' ||
          o.aiSummary?.docContent?.status === 'PROCESSING' ||
          o.aiSummary?.scAnalysis?.status === 'PREPARING' ||
          o.aiSummary?.scAnalysis?.status === 'PROCESSING',
      );
      return hasProcessing ? 20_000 : false;
    },
  });
}
